import { IZonesResponse } from "@/entities";
import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { IZoneService } from "@/services/backend/zone/zone.types";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class ZoneService implements IZoneService {
  async getZones(clientId: number): Promise<IZonesResponse | undefined> {
    const params = { clientId };

    const { response, error } = await handleResponse<IZonesResponse, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/zone`, { params })
    );

    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
